import React from 'react';
import LanguageSwitcher from "./LanguageSwitcher";
import UserMenuList from "./UserMenuList";
import { useSelector } from "react-redux";

/**
 * Notification component
 * @param props
 * @returns {*}
 * @constructor
 */
function NotificationBar(props) {
    const user = useSelector(state => state.user);
    return (

        <ul className="right-menus">
            <li>
                <LanguageSwitcher/>
            </li>
            <li className="login-field">
                <UserMenuList user={user} openFeedbackModel={props.openFeedbackModel}/>
            </li>
        </ul>

    );
}

export default NotificationBar;
